import React, { useState, useEffect, useMemo } from 'react';
import Analytics from './Analytics';
import Contacts from './Contacts';
import Vcard from './VCard';
import Inbox from './Inbox';
import QrCode from './QrCode';
import QuickButtons from './QuickButtons';
import { useAuth } from '../../utils/Auth';
import MarketingButtons from './MarketingButtons';
import Jobs from './Jobs';
import Scheduling from './Scheduling';
import Carousel from './Carousel';
import { motion } from 'motion/react';
import { containerVariants, headerVariants, transition } from './variants';
import styles from './SettingsContainer.module.css';
import SimpleRedirect from './SimpleRedirect';

// Main settings component
export default function SettingsContainer2(props) {

    const { fromEventRegisterAddPP } = props;
    const { vcardObj, userObj } = useAuth();
    const windowWidth = window.innerWidth;

    const [show, setShow] = useState({
        form: fromEventRegisterAddPP ? 'edit-profile-image' : '',
        card: false
    });

    const handleShowForm = (val) => setShow(prev => ({ ...prev, form: val }));
    const handleShowCard = (val) => setShow(prev => ({ ...prev, card: val }));

    useEffect(() => {
        const left = document.querySelector(`.${styles.left}`);
        const right = document.querySelector(`.${styles.right}`);

        show.card ? left.classList.add(styles.hide) : left.classList.remove(styles.hide);
        show.card ? right.classList.remove(styles.hide) : right.classList.add(styles.hide);
    }, [show.card]);

    const headerHelper = useMemo(() => {
        const first = vcardObj?.name_first;
        const last = vcardObj?.name_last;
    
        if (first && last) {
            return `Welcome, ${first} ${last}!`
        } else if (first && !last) {
            return `Welcome, ${first}!`
        } else if (!first && last) {
            return `Welcome, ${last}!`
        } else {
            return 'Welcome, user!'
        };
    }, [vcardObj.name_first, vcardObj.name_last]);

    const handlePageTypeReturn = useMemo(() => {
        switch (userObj.page_type) {
            case 'simple-redirect':
                return <SimpleRedirect />;
            case 'vcard':
            default:
                return <Vcard showForm={show.form} setShowForm={handleShowForm} />
        }
    },[userObj.page_type, show.form]);

    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <div className={styles.headerContainerWords}>
                    <motion.div className={styles.header} variants={headerVariants} custom={windowWidth} transition={transition} initial='offscreen' whileInView='onscreen' viewport={{once: true}}>Settings Dashboard</motion.div>
                    <motion.div className={styles.subheader} variants={headerVariants} custom={windowWidth} transition={windowWidth <= 600 ? {...transition} : {...transition, delay: .2}} initial='offscreen' whileInView='onscreen' viewport={{once: true}}>{headerHelper}</motion.div>
                </div>
                <QuickButtons showCard={show.card} setShowCard={handleShowCard} />
            </div>
            <motion.div className={styles.content} variants={containerVariants} transition={transition} initial='offscreen' whileInView='onscreen' viewport={{once: true}}>
                <div className={styles.left}>
                    <MarketingButtons />
                    <Analytics />
                    <QrCode />
                    <Contacts />
                    <Inbox />
                    <Jobs />
                    <Scheduling />
                    <Carousel show={window.innerWidth <= 768} />
                </div>
                <div className={styles.right}>
                    {handlePageTypeReturn}
                    <Carousel show={window.innerWidth > 768} />
                </div>
            </motion.div>
        </div>
    );
};